import type { ReactNode } from 'react'
import { Card as MuiCard, CardContent, Stack } from '@mui/material'
import type { SxProps, Theme } from '@mui/material/styles'

import { TestCreateSectionHeader } from './TestCreateSectionHeader'

/** Якорь секции для оглавления формы: `scrollMarginTop` держит заголовок под шапкой. */
const SECTION_CARD_SX: SxProps<Theme> = {
  scrollMarginTop: 16,
  p: 0,
}

/** Padding секций формы — как у панели предпросмотра (`Paper` с `p: 2`), без увеличенного `pb` у последнего `CardContent`. */
const SECTION_CARD_CONTENT_SX: SxProps<Theme> = {
  p: 2,
  '&:last-child': { pb: 2 },
}

/**
 * Карточка секции конструктора теста: рамка, отступы, иконка и заголовок.
 *
 * Форм две — тест из урока и самостоятельный тест ученика, — и до выноса они
 * держали свои копии этой обвязки. Общая карточка нужна, чтобы секции не
 * разъезжались по отступам и якорям оглавления.
 */
export function TestCreateSection({
  id,
  icon,
  title,
  spacing = 2,
  children,
}: {
  /** Якорь для оглавления формы. */
  id: string
  icon: ReactNode
  title: string
  /** Секции с вложенными подблоками дышат шире — как фильтры слов. */
  spacing?: number
  children: ReactNode
}) {
  return (
    <MuiCard id={id} sx={SECTION_CARD_SX}>
      <CardContent sx={SECTION_CARD_CONTENT_SX}>
        <Stack spacing={spacing}>
          <TestCreateSectionHeader icon={icon} title={title} />
          {children}
        </Stack>
      </CardContent>
    </MuiCard>
  )
}
